import { render } from "./BuyMoreCredits.vue?vue&type=template&id=3e6384d8&scoped=true"
import script from "./BuyMoreCredits.vue?vue&type=script&lang=js"
export * from "./BuyMoreCredits.vue?vue&type=script&lang=js"

import "./BuyMoreCredits.vue?vue&type=style&index=0&id=3e6384d8&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e6384d8"]])

export default __exports__